import { gql } from "@apollo/client";

export const WORK_ORDERS_QUERY = gql`query WorkOrders {
    workOrders {
        totalCount
        nodes {
            id
            title
            description
            severity
            locationId
            parentId
            workOrderType
            workOrderServiceCategory
            workOrderStageId
            startDate
            endDate
            timeZone
            attachments
            createdBy
            createdAt
            updatedAt
            deletedAt
            executionPriority
            location {
                id
                locationName
                description
                locationType
                locationTypeName
                address
                city
                state
                zipcode
                country
                coordinates
                parentId
                fileIds
                createdAt
                updatedAt
                deletedAt
            }
            workOrderStage {
                id
                name
                color_code
                is_default
                display_order
                created_at
                updated_at
            }
            workOrderAssets {
                id
                workOrderId
                assetId
                assetServiceTypeId
                assetFileIds
                locationFileIds
                createdAt
                locationId
                locationType
                locationTypeName
            }
            workOrderAssignments {
                id
                workOrderId
                userIds
                assignmentType
                createdAt
                updatedAt
                deletedAt
            }
            parent {
                id
                title
                description
                severity
                locationId
                parentId
                workOrderType
                workOrderServiceCategory
                workOrderStageId
                startDate
                endDate
                timeZone
                attachments
                createdBy
                createdAt
                updatedAt
                deletedAt
                executionPriority
            }
        }
    }
}`;

// Get Single Work Order by ID Query

export const GET_WORK_ORDER_QUERY = gql`
  query WorkOrder($id: ID!) {
  workOrder(id: $id) {
    id
        title
        description
        severity
        locationId
        parentId
        workOrderType
        workOrderServiceCategory
        workOrderStageId
        startDate
        endDate
        timeZone
        attachments
        createdBy
        createdAt
        updatedAt
        deletedAt
        executionPriority
        location {
            id
            locationName
            description
            locationType
            locationTypeName
            address
            city
            state
            zipcode
            country
            coordinates
            parentId
            fileIds
            createdAt
            updatedAt
            deletedAt
        }
        workOrderStage {
            id
            name
            color_code
            is_default
            display_order
            created_at
            updated_at
        }
        workOrderAssets {
            id
            workOrderId
            assetId
            assetServiceTypeId
            assetFileIds
            locationFileIds
            createdAt
            locationId
            locationType
            locationTypeName
        }
        workOrderAssignments {
            id
            workOrderId
            userIds
            assignmentType
            createdAt
            updatedAt
            deletedAt
        }
        parent {
            id
            title
            description
            severity
            locationId
            parentId
            workOrderType
            workOrderServiceCategory
            workOrderStageId
            startDate
            endDate
            timeZone
            attachments
            createdBy
            createdAt
            updatedAt
            deletedAt
            executionPriority
        }
    }
}`;

// Company Users Query
